module.exports = __webpack_public_path__ + "static/ja-logo-b1c7cdb7f8c4e74d8ed38f5990c62f1c.png";